module.exports = __webpack_public_path__ + "static/media/osha.6f581be7.svg";